import React, { useState, useEffect, useCallback, useRef } from "react";
import useAppContext, { actions } from "../../../utils/Reducers";
import { useAxiosWithAuthorization } from "../../../utils/api";
import SelectBox from "../../../components/SelectBox";
import ModalFactory from "react-modal-promise";
import "../../../styles/mobile/css/mo.css";
import "../../../styles/mobile/css/imglink.css";
import "../../../styles/mobile/css/font-ko.css";
import Incoming from "../Incoming";
import Insepection from "../Inspection";
import Outgoing from "../outgoing";
import Driving from "../Driving";
import Weighting from "../Weighting";
import BWeighting from "../BWeighting";
import WeightInfo from "../WeightInfo";
import { useInterval } from "../../../utils/validators";
import { IronTwoTone } from "@mui/icons-material";

const Main = (props) => {
  const { dispatch } = useAppContext();

  const incomingRef = useRef();
  const inspectionRef = useRef();
  const outgoingRef = useRef();
  const drivingRef = useRef();
  const weightingRef = useRef();
  const bweightingRef = useRef();
  const weightInfoRef = useRef();

  const {
    store: { userInfo, tabSize },
  } = useAppContext();

  const [searchParameters, setSearchParameters] = useState({
    schSystemCd:
      userInfo.defaultCompNo !== null
        ? userInfo.defaultCompNo
        : userInfo.systemCd,
    schPlantCd:
      userInfo.defaultPlantNo !== null
        ? userInfo.defaultPlantNo
        : userInfo.systemCd === "YK"
        ? "GP"
        : "NS",

    schSearch: "",
    schOdrType: "10",
  });

  const [menuTab, setMenuTab] = useState("incoming");

  const [bmenuTab, setBmenuTab] = useState("scrap");

  const initItem = {
    realWeight: "",
    statusD: "",
    statusI: "",
    statusS: "",
    statusT: "",
    statusTotal: "",
    statusW: "",
  };

  const [fieldValues, setFieldValues] = useState(initItem);

  //오늘 하루 통합 운송량 검색 URL
  const SP_SEARCH_TRANS_TOTAL_COUNT =
    "/mobileweb/inspection/SP_SEARCH_TRANS_TOTAL_COUNT.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SP_SEARCH_TRANS_TOTAL_COUNT,
    },
    { manual: true }
  );

  useInterval(async () => {
    //console.log(searchParameters);
    await searchTransTotalCount(searchParameters);

    await onTabSearch(searchParameters);
  }, 10000);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    searchTransTotalCount(searchParameters);
  }, []);

  const searchTransTotalCount = async (items) => {
    const {
      data: { data },
    } = await fetchData({
      url: SP_SEARCH_TRANS_TOTAL_COUNT,
      params: items,
    });

    setFieldValues(data[0]);
  };

  const handleChangeField = useCallback(async (event) => {
    const { name, value } = event.target;
    //console.log("name === " + name + " || value === " + value);
    let item = {};
    var schPlantCd = "";
    if (name === "schSystemCd") {
      if (value === "YK") {
        schPlantCd = "GP";
      } else {
        schPlantCd = "NS";
      }

      item = {
        ...searchParameters,
        [name]: value,
        ["schPlantCd"]: schPlantCd,
      };
    } else {
      item = {
        ...searchParameters,
        [name]: value,
      };
    }

    await onTabSearch(item);
    await searchTransTotalCount(item);

    setSearchParameters(item);
  });

  const onTabSearch = async (item) => {
    if (menuTab === "incoming") {
      await incomingRef.current.onSearch(item);
    } else if (menuTab === "inspectionwait") {
      await inspectionRef.current.onSearch(item);
    } else if (menuTab === "outgoing") {
      await outgoingRef.current.onSearch(item);
    } else if (menuTab === "driving") {
      await drivingRef.current.onSearch(item);
    } else if (menuTab === "tweighting") {
      await weightingRef.current.onSearch(item);
    } else if (menuTab === "bweighting") {
      await bweightingRef.current.onSearch(item);
    } else if (menuTab === "weightinfo") {
      await weightInfoRef.current.onSearch(item);
    }
  };

  const onMenuTab = async (menuNm) => {
    setMenuTab(menuNm);
    await onTabSearch(searchParameters);
  };

  const onBmenuTab = (menuNm) => {
    setBmenuTab(menuNm);
    if (menuNm === "weighting") {
      setMenuTab("tweighting");
    } else {
      setMenuTab("incoming");
    }

    var odrType = "";
    // eslint-disable-next-line no-unused-expressions
    menuNm === "scrap"
      ? (odrType = "10")
      : menuNm === "sea"
      ? (odrType = "30")
      : menuNm === "import"
      ? (odrType = "40")
      : menuNm === "transfer"
      ? (odrType = "80")
      : menuNm === "weighting"
      ? (odrType = "10")
      : "";

    setSearchParameters({
      ...searchParameters,
      schOdrType: odrType,
    });

    onTabSearch({
      ...searchParameters,
      ["schOdrType"]: odrType,
    });

    searchTransTotalCount({
      ...searchParameters,
      ["schOdrType"]: odrType,
    });
  };

  const onSearch = (event) => {
    if (event.keyCode === 13) {
      onTabSearch(searchParameters);
      searchTransTotalCount(searchParameters);
    }
  };

  const onButtonSearch = () => {
    onTabSearch(searchParameters);
    searchTransTotalCount(searchParameters);
  };

  const onLogout = () => {
    dispatch(actions.logout());
  };

  return (
    <>
      <div className="top">
        <div className="menu">
          <div className="goback">
            <button onClick={onLogout}></button>
          </div>
          <div className="selectBox">
            <SelectBox
              mastCd="SYSTEM_CD"
              id="schSystemCd"
              name="schSystemCd"
              disabled={userInfo.defaultPlantNo !== null ? true : false}
              onChange={handleChangeField}
              value={searchParameters.schSystemCd}
              className="datainput"
              style={{ width: "250px" }}
            />
            <SelectBox
              mastCd="PLANT_CD"
              id="schPlantCd"
              name="schPlantCd"
              attr5="Y"
              attr1={searchParameters.schSystemCd}
              onChange={handleChangeField}
              value={searchParameters.schPlantCd}
              label="attr9"
              className="datainput"
              style={{ width: "200px" }}
            />
          </div>
        </div>
        <ul className="mdata">
          <li>
            <div>전체</div>
            <div>{fieldValues.statusTotal}</div>
          </li>
          <li>
            <div>입고</div>
            <div>{fieldValues.statusS}</div>
          </li>
          <li className="w50">
            <div>
              입고
              <br />
              총량
            </div>
            <div>{fieldValues.realWeight} kg</div>
          </li>
          <li>
            <div>
              검수
              <br />
              대기
            </div>
            <div>{fieldValues.statusW}</div>
          </li>
          <li>
            <div>
              출차
              <br />
              대기
            </div>
            <div>{fieldValues.statusI}</div>
          </li>
          <li>
            <div>운송</div>
            <div>{fieldValues.statusD}</div>
          </li>
          <li>
            <div>
              운송
              <br />
              대기
            </div>
            <div>{fieldValues.statusT}</div>
          </li>
        </ul>
        <ul
          className={
            bmenuTab === "scrap" || bmenuTab === "sea"
              ? "tab"
              : bmenuTab === "import"
              ? "tab triple"
              : "tab twin"
          }
        >
          {bmenuTab !== "weighting" ? (
            <li onClick={(event) => onMenuTab("incoming")}>
              <div className={menuTab === "incoming" ? "on" : ""}>입차호출</div>
            </li>
          ) : (
            ""
          )}
          {bmenuTab === "scrap" || bmenuTab === "sea" ? (
            <>
              <li onClick={(event) => onMenuTab("inspectionwait")}>
                <div className={menuTab === "inspectionwait" ? "on" : ""}>
                  검수대기
                </div>
              </li>
              <li onClick={(event) => onMenuTab("outgoing")}>
                <div className={menuTab === "outgoing" ? "on" : ""}>
                  출차대기
                </div>
              </li>
            </>
          ) : (
            ""
          )}
          {bmenuTab === "import" ? (
            <>
              <li onClick={(event) => onMenuTab("weightinfo")}>
                <div className={menuTab === "weightinfo" ? "on" : ""}>
                  계근정보
                </div>
              </li>
            </>
          ) : (
            ""
          )}
          {bmenuTab !== "weighting" ? (
            <li onClick={(event) => onMenuTab("driving")}>
              <div className={menuTab === "driving" ? "on" : ""}>운송</div>
            </li>
          ) : (
            ""
          )}
          {bmenuTab === "weighting" ? (
            <li onClick={(event) => onMenuTab("tweighting")}>
              <div className={menuTab === "tweighting" ? "on" : ""}>
                입고실적
              </div>
            </li>
          ) : (
            ""
          )}

          {bmenuTab === "weighting" ? (
            <li onClick={(event) => onMenuTab("bweighting")}>
              <div className={menuTab === "bweighting" ? "on" : ""}>
                전일입고실적
              </div>
            </li>
          ) : (
            ""
          )}
        </ul>

        <div className="sch">
          <input
            type="search"
            id="schSearch"
            name="schSearch"
            placeholder="검색어 입력"
            onChange={handleChangeField}
            value={bmenuTab === "weighting" ? "" : fieldValues.schSearch}
            onKeyDown={onSearch}
            disabled={bmenuTab === "weighting" ? true : false}
            style={{ backgroundColor: "#FFFFFF" }}
          />
          <div className="icon">
            <button onClick={onButtonSearch}></button>
          </div>
        </div>
      </div>
      <div className="wrapper">
        <div className="conm">
          {menuTab === "incoming" ? (
            <Incoming
              ref={incomingRef}
              searchParameters={searchParameters}
              bmenuTab={bmenuTab}
            />
          ) : menuTab === "inspectionwait" ? (
            <Insepection
              ref={inspectionRef}
              searchParameters={searchParameters}
              bmenuTab={bmenuTab}
            />
          ) : menuTab === "outgoing" ? (
            <Outgoing
              ref={outgoingRef}
              searchParameters={searchParameters}
              bmenuTab={bmenuTab}
            />
          ) : menuTab === "driving" ? (
            <Driving
              ref={drivingRef}
              searchParameters={searchParameters}
              bmenuTab={bmenuTab}
            />
          ) : menuTab === "weightinfo" ? (
            <WeightInfo
              searchParameters={searchParameters}
              ref={weightInfoRef}
              bmenuTab={bmenuTab}
            />
          ) : menuTab === "tweighting" ? (
            <Weighting
              searchParameters={searchParameters}
              ref={weightingRef}
              bmenuTab={bmenuTab}
            />
          ) : menuTab === "bweighting" ? (
            <BWeighting
              searchParameters={searchParameters}
              ref={bweightingRef}
              bmenuTab={bmenuTab}
            />
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="bot">
        <ul className="tab">
          <li onClick={(event) => onBmenuTab("scrap")}>
            <div className={bmenuTab === "scrap" ? "on" : ""}>국내스크랩</div>
          </li>
          <li onClick={(event) => onBmenuTab("sea")}>
            <div className={bmenuTab === "sea" ? "on" : ""}>국내해상</div>
          </li>
          <li onClick={(event) => onBmenuTab("import")}>
            <div className={bmenuTab === "import" ? "on" : ""}>수입고철</div>
          </li>
          <li onClick={(event) => onBmenuTab("weighting")}>
            <div className={bmenuTab === "weighting" ? "on" : ""}>입고실적</div>
          </li>
        </ul>
      </div>
      <ModalFactory />
    </>
  );
};

export default Main;
